import { Link } from '@inertiajs/react'
import { Box, Text } from '@mantine/core'
import { TILE } from './stations/_tiles'
import './_list.css'

// Shared navy tile-card list treatment — a colored header band over
// hairline-divided rows, in the station pages' brand palette (identical in light
// and dark). Used by the home list and the country/state/city location pages.

export function ListCard({ title, children }) {
  return (
    <Box
      style={{
        borderRadius: 12,
        overflow: 'hidden',
        background: TILE.dark,
        color: '#fff',
      }}
    >
      <Text
        px="md"
        py={9}
        fw={700}
        tt="uppercase"
        fz="0.85rem"
        style={{ letterSpacing: 0.6, background: TILE.mid }}
      >
        {title}
      </Text>
      {children}
    </Box>
  )
}

// A single row: a full-width link, white name, optional muted sub-line (e.g.
// distance). Hairline top border separates rows.
export function ListRow({ href, name, sub }) {
  return (
    <Link
      href={href}
      className="tnm-list-row"
      style={{
        display: 'block',
        color: '#fff',
        textDecoration: 'none',
        padding: '13px 16px',
        borderTop: '1px solid rgba(255,255,255,0.10)',
      }}
    >
      <Text fz="1.1rem" fw={500} lh={1.2}>
        {name}
      </Text>
      {sub && (
        <Text fz="0.9rem" mt={3} style={{ color: 'rgba(255,255,255,0.6)' }}>
          {sub}
        </Text>
      )}
    </Link>
  )
}
